<template>
  <div>
    <!-- Desktop: b-modal handles centering / backdrop -->
    <b-modal
      v-if="!isMobile"
      id="loginModal"
      :visible="value"
      centered
      hide-header
      hide-footer
      body-class="p-0 login-modal-body"
      content-class="border-0 rounded-20 shadow-lg modal-bg-transparent"
      dialog-class="login-modal-dialog"
      footer-class="border-0"
      :modal-class="modalClass"
      no-close-on-backdrop
      no-close-on-esc
      no-enforce-focus
      v-bind="$attrs"
      v-on="listeners"
    >
      <slot />
    </b-modal>

    <!-- Mobile: plain fixed overlay — no b-modal height fighting -->
    <div
      v-else-if="isMobile && value"
      id="loginModal"
      class="mobile-login-overlay"
      :class="modalClass"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginModalShell",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    modalClass: {
      default: null,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listeners() {
      // Forward all listeners except input so b-modal sync works
      // eslint-disable-next-line no-unused-vars
      const { input: _input, ...rest } = this.$listeners || {};
      return {
        ...rest,
        // b-modal emits 'update:value' via v-model — bridge it
        hide: (...args) => {
          this.$emit("input", false);
          if (rest.hide) rest.hide(...args);
        },
        show: (...args) => {
          if (rest.show) rest.show(...args);
        },
      };
    },
  },
  watch: {
    // Lock / unlock body scroll when the mobile overlay opens/closes
    value(isOpen) {
      if (this.isMobile) {
        if (isOpen) {
          document.body.classList.add("login-modal-open-mobile");
          document.documentElement.classList.add("login-modal-open-mobile");
        } else {
          document.body.classList.remove("login-modal-open-mobile");
          document.documentElement.classList.remove("login-modal-open-mobile");
        }
        // Mirror b-modal's show/hide events so parent listeners fire on mobile too
        this.$emit(isOpen ? "show" : "hide");
      }
    },
    isMobile(val) {
      // If we switch breakpoints while open, restore scroll
      if (!val) {
        document.body.classList.remove("login-modal-open-mobile");
        document.documentElement.classList.remove("login-modal-open-mobile");
      }
    },
  },
  beforeDestroy() {
    document.body.classList.remove("login-modal-open-mobile");
    document.documentElement.classList.remove("login-modal-open-mobile");
  },
};
</script>

<style>
html.login-modal-open-mobile,
body.login-modal-open-mobile {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}
</style>

<style scoped>
/* ── Mobile overlay — replaces everything b-modal was adding ── */
.mobile-login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000 !important;
  overflow-y: auto;
  background: #fff;
}
body.has-mobile-banner .mobile-login-overlay {
  top: 136px;
}
</style>
